import { Backdrop, Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomTextField from "../../../components/customFields/CustomTextField";
import BlueSmallButton from "../../../components/customButtons/BlueSmallButton";
import PrimarySmallBlueButton from "../../../components/customButtons/PrimarySmallBlueButton";
import DisableBlueSmallButton from "../../../components/customButtons/DisableSmallBlueButton";
import {
  handleFetchClassExtensionOrderApi,
  handleFetchOrderApi,
  handleVerifyPayment,
  saveRezorpayPayment,
} from "../../testPrepDashboard/Api/DashboardApi";
import ErrorPopupScreen from "../../../components/customPopup/ErrorPopupScreen";
import Loader from "../../../../SAPPages/components/Loader/Loader";
import InfoIcon from "@mui/icons-material/Info";
export default function UpgradeClassForm({
  classData,
  handleOpenSuccessPopup,
  handleClose,
  setErrorMessage,
  errorMessage,
}) {
  const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
  const [session, setSession] = useState(null);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const userId = localStorage.getItem("userId");

  const [paymentProceessLoading, setPaymentProcessLoading] = useState(false);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);

  const [buttonTitle, setButtonTitle] = useState("Okay");

  const defaultAddressId = classData?.id;
  console.log("classData", classData);

  const extensionAmount =
    classData?.package_id?.currency === "INR"
      ? 350
      : classData?.package_id?.currency === "NPR"
      ? 500
      : 350;

  const Total_Amount =
    classData?.package_id?.currency === "INR"
      ? extensionAmount * session
      : classData?.package_id?.currency === "NPR"
      ? extensionAmount * session
      : extensionAmount * session;

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    setPaymentProcessLoading(true);

    const orderDetails = {
      std_class_detail_id: classData?.id,
      number_of_extended_sessions: session,
      total_amount: Total_Amount,
      payment_mode_id: 2,

      payment_status: "pending",
      is_class_extension: true,
      user_id: parseInt(userId),

      currency: classData?.package_id?.currency,
    };

    let orderData;

    // Create order

    try {
      const response = await handleFetchClassExtensionOrderApi({
        ...orderDetails,
      });

      if (response.status === 201) {
        orderData = response?.data?.order_res;

        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
          alert("Razorpay SDK failed to load. Are you online?");
          return;
        }

        const options = {
          key: `${RAZORPAY_KEY_ID}`,
          amount: orderData?.amount,
          currency: orderData?.currency,
          name: "Scholastic Test Masters",
          description: "Secure payment for your selected class package",
          image: "/stm-logo-dark 1 (2).png",
          order_id: orderData?.id,
          handler: async function (response) {
            const rezorpayResponse = response;

            // Run Verify payment api

            try {
              const response = await handleVerifyPayment(rezorpayResponse);

              if (response.status === 200) {
                setErrorMessage(response?.message);
                handleClose();
                handleOpenSuccessPopup();

                setPaymentProcessLoading(false);
              } else if ([400, 409].includes(response.status)) {
                setErrorMessage(response?.message);
                setButtonTitle("Got It");
                handleOpenErrorPopup();
                setPaymentProcessLoading(false);
              } else {
                setErrorMessage(response?.message);
                setButtonTitle("Got It");
                handleOpenErrorPopup();
                setPaymentProcessLoading(false);
              }
            } catch (err) {
              setErrorMessage(response?.message);
              setButtonTitle("Got It");
              handleOpenErrorPopup();
              setPaymentProcessLoading(false);
            }
          },
          prefill: {
            // name: billingData?.fullName, // Prepopulate customer name if available
            // email: { email }, // Prepopulate customer email if available
          },
          modal: {
            confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.

            ondismiss: function (reason) {
              switch (reason) {
                case undefined:
                  setErrorMessage("You have cancelled the payment.");
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "timeout":
                  setErrorMessage(
                    "Your payment session timed out. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_failed":
                  setErrorMessage(
                    "Your payment failed. Please try again or use a different payment method."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_cancelled":
                  setErrorMessage(
                    "The payment was cancelled. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_declined":
                  setErrorMessage(
                    "Your payment was declined. Please check with your bank or try another method."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_timed_out":
                  setErrorMessage("Your payment timed out. Please try again.");
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_collect_request_expired":
                  setErrorMessage(
                    "The payment request expired. Please initiate a new payment."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                default:
                  setErrorMessage(
                    "An unknown error occurred. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
              }
            },
          },
          timeout: 900,
          theme: {
            color: "#572575", // Customize the theme color as per your requirement
          },
        };

        const razorpay = new window.Razorpay(options);

        razorpay.on("payment.failed", function (response) {
          console.error("Razorpay payment.failed event:", response);

          setErrorMessage(
            response.error?.description ||
              "Payment failed. Please try again or use a different payment method."
          );
          setButtonTitle("Retry Payment");
          handleOpenErrorPopup();
          setPaymentProcessLoading(false);
        });

        document.body.style.overflow = "auto";

        try {
          razorpay.open();
        } catch (error) {
          console.error("Razorpay Checkout error:", error);
          setErrorMessage(error.description);
          setButtonTitle("Retry Payment");
          handleOpenErrorPopup();
          setPaymentProcessLoading(false);
        }
      } else if ([400, 409].includes(response.status)) {
        setErrorMessage(response?.message);
        setButtonTitle("Got It");
        handleOpenErrorPopup();
        setPaymentProcessLoading(false);
      } else {
        setErrorMessage("Internal Server Error");
        setButtonTitle("Got It");
        handleOpenErrorPopup();
        setPaymentProcessLoading(false);

        document.body.style.overflow = "auto";
      }
    } catch (error) {
      setErrorMessage("Internal Server Error");
      setButtonTitle("Got It");
      handleOpenErrorPopup();
      setPaymentProcessLoading(false);
      document.body.style.overflow = "auto";
    }
  };

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  const min = 1;
  const max = 60;

  const handleChange = (event) => {
    const newValue = parseInt(event.target.value, 10);

    if (isNaN(newValue)) {
      setSession("");
      setError(true);
      setHelperText("Please enter a valid number.");
    } else if (newValue > max) {
      setSession(newValue);
      setError(true);
      setHelperText(`Value cannot be more than ${max}.`);
    } else if (newValue < min) {
      setSession(newValue);
      setError(true);
      setHelperText(`Value must be at least ${min}.`);
    } else {
      setSession(newValue);
      setError(false);
      setHelperText("");
    }
  };
  return (
    <>
      <Grid container spacing={2}>
        {paymentProceessLoading && (
          <Grid item xs={12}>
            <Backdrop open={paymentProceessLoading} style={{ zIndex: 9999 }}>
              <Loader text="Processing your payment, please wait..." />
            </Backdrop>
          </Grid>
        )}
        <Grid item xs={12} textAlign="center">
          <Typography
            color="#572575"
            fontFamily="Inter"
            fontSize="20px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            Extend Class Sessions
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              width: "100%",
              height: "2px",
              background:
                "linear-gradient(to right, #FFFFFF, #A120BB, #FFFFFF)",
            }}
          ></Box>
        </Grid>

        <Grid item xs={12} mt={1}>
          <Typography
            color="#161719"
            fontFamily="Inter"
            fontSize="14px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Session to add{" "}
            <Tooltip
              arrow
              title={`${extensionAmount} ${classData?.package_id?.currency} will be charged for each extended session.`}
            >
              <InfoIcon
                style={{
                  fontSize: "1rem",
                  marginLeft: 1,
                  color: "#555555",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </Typography>
          <CustomTextField
            fullWidth
            type="number"
            borderColor="#A9A4BD"
            value={session}
            onChange={handleChange}
            error={error}
            helperText={helperText}
           
          />
        </Grid>

        {session >= min && session <= max && (
          <Grid item xs={12} container justifyContent="space-between" mt={1}>
            <Typography
              color="#161719"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              mb={1}
              style={{ fontWeight: 400 }}
            >
              Amount to pay
            </Typography>

            <Typography
              color="#572575"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              mb={1}
              style={{ fontWeight: 700 }}
            >
              {Total_Amount} {classData?.package_id?.currency}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12} mt={1}>
          {!session || session < min || session > max ? (
            <DisableBlueSmallButton buttonTitle="Proceed To Pay" width="100%" />
          ) : (
            <PrimarySmallBlueButton
              buttonTitle="Proceed To Pay"
              width="100%"
              onClick={handlePayment}
            />
          )}
        </Grid>
      </Grid>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle={buttonTitle}
        // startIcon={<ArticleIcon />}

        maxWidth="xs"
      />
    </>
  );
}
